import {Injectable} from '@angular/core';
import {BrandManager} from 'src/app/data/manager/brand/brand.manager';

@Injectable({
  providedIn: 'root',
})
export class BrandVm {
  constructor(private brandManager: BrandManager) { }

  getBrand(data, screenSize) {
    return this.brandManager.getBrand(data, screenSize);
  }
}
